import { withTranslate } from '@i18n/utils'
import { countries, getStates, getStateValue, getCountryValue } from 'shared/states'
import Select from '@components/Select/RequiredSelectWithFormsy'

export const CountryStateSelects = withTranslate(
    ({ isNewUser, selectedCountry, selectedState, setSelectedCountry, setSelectedState, translate: t }) => (
        <>
            <div className={isNewUser && 'form-group form-control header-form-input'}>
                <Select
                    inputId="countrySelect"
                    ariaLabel={t('dashboard.label.country.select')}
                    className={!isNewUser && 'mb-3'}
                    options={countries}
                    onChange={setSelectedCountry}
                    isSearchable={true}
                    getSelectValue={getCountryValue}
                    value={selectedCountry}
                    name={'country'}
                    placeholder={t('dashboard.account.country')}
                    required
                />
            </div>
            <div className={isNewUser && 'form-group form-control header-form-input'}>
                <Select
                    inputId="stateSelect"
                    ariaLabel={t('dashboard.label.state.select')}
                    className={!isNewUser && 'mb-3'}
                    options={getStates(selectedCountry)}
                    onChange={setSelectedState}
                    isSearchable={true}
                    getSelectValue={getStateValue(selectedCountry)}
                    value={selectedState}
                    name={'state'}
                    placeholder={t('dashboard.account.state')}
                    required
                />
            </div>
        </>
    )
)
